import React from 'react';
import DropdownMenu from './../../miscellaneous/container/DropdownMenu';
import { CREATE_INFORM, FORM } from './../../constants/strings/StringsDashboard';
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";

import PdfIcon from '@material-ui/icons/PictureAsPdf';
import SaveIcon from '@material-ui/icons/Save';
import SaveOutIcon from '@material-ui/icons/SaveOutlined';
import OpenIcon from '@material-ui/icons/FolderOpen';
import NewIcon from '@material-ui/icons/InsertDriveFileOutlined';


function InformeComponent({
  acumulatedGraphics,
  workGraphics,
  onGraphicContext,
  preventDefault,
  menus,
  handlerDragStart,
  handlerDrop,
  handrlerDobleClickWS,
  handlerPasteText,
  handlerClickText,
  handlerDbclickText,
  handlerChangeText,
  onNew,
  onOpen,
  onSave,
  onSaveAs,
  onPdf,
  onTouchStart,
  onTouchEnd,
  fileText
}) {
  return (

    <div className="container">
      <div className="images-container"
        draggable
        onDragOver={preventDefault}
      >
        {
          !!acumulatedGraphics.length &&
          acumulatedGraphics.map((graphic, index) => {
            return (
              <div className="images-item" onContextMenu={(event) => onGraphicContext(event, graphic.type)} key={`graphic-select-${index}`}>
                <img src={graphic.graphic}
                  alt=""
                  draggable
                  id={"drag-" + graphic.id}
                  onDragStart={handlerDragStart} />
              </div>
            )
          })
        }
        {
          !acumulatedGraphics.length &&
          <div
            className="images-item no-actions"
            onContextMenu={preventDefault}
            unselectable='on'
            onMouseDown={() => { return false; }}
            onSelect={() => { return false; }}
          >
            {CREATE_INFORM.NO_GRAPHICS}
          </div>
        }
      </div>
      <div className='inform-container'>
        <div>
          <h1 className="page-title">{LANDING_MENU_BAR.CREATE_INFORMS}</h1>
        </div>
        <div className='toolbar'>
          {
            menus.map((val, i) => {
              return (
                <DropdownMenu metaData={val} key={'menu-drop-' + i} />
              )
            })
          }
          <div className='file-title'>{fileText}</div>
          <button onClick={onNew} className="menu-bar-icon" title={FORM.NEW}><NewIcon /></button>
          <button onClick={onOpen} className="menu-bar-icon" title={FORM.OPEN}><OpenIcon /></button>
          <button onClick={onSave} className="menu-bar-icon" title={FORM.SAVE}><SaveOutIcon /></button>
          <button onClick={onSaveAs} className="menu-bar-icon" title={FORM.SAVE_AS}><SaveIcon /></button>
          <button onClick={onPdf} className="menu-bar-icon" title={FORM.PDF}><PdfIcon /></button>
        </div>
        <div className="work-space">
          <div className="work-sheet" id="work-sheet"
            // draggable
            onDrop={handlerDrop}
            onDragOver={preventDefault}
            onDoubleClick={handrlerDobleClickWS}
          // onContextMenu={preventDefault}
          >
            {
              !!workGraphics.length &&
              workGraphics.map((graphic, index) => {
                if (graphic.type === 'img' || graphic.type === 'shield') {
                  return (
                    <img
                      src={graphic.graphic}
                      alt=""
                      key={`graphic-ws-${index}`}
                      draggable
                      id={((graphic.type === 'img') ? "drag-" : "shield-") + graphic.id}
                      onDragStart={handlerDragStart}
                      onContextMenu={(event) => onGraphicContext(event, graphic.type)}
                      onTouchStart={(event) => onTouchStart(event, graphic.type)}
                      onTouchEnd={(event) => onTouchEnd(event, graphic.type)}
                      className="resize-drag resize-container"
                      data-x={graphic.x}
                      data-y={graphic.y}
                      style={{
                        height: graphic.height + 'px',
                        width: graphic.width + 'px',
                        transform: `translate(${graphic.x}px, ${graphic.y}px)`
                      }}
                    />
                  )
                } else if (graphic.type === 'text') {
                  return (
                    <div key={`text-grapper-${index}`}
                      className='cuadrado drag'
                      data-x={graphic.x}
                      data-y={graphic.y}
                      style={{
                        minHeight: graphic.height + 'px',
                        width: graphic.width + 'px',
                        transform: `translate(${graphic.x}px, ${graphic.y}px)`
                      }}
                    >
                      <div
                        key={`text-content-${index}`}
                        id={"instance-" + graphic.id}
                        onPaste={handlerPasteText}
                        onClick={handlerClickText}
                        onDoubleClick={handlerDbclickText}
                        onBlur={handlerChangeText}
                        contentEditable={true}
                        onContextMenu={(event) => onGraphicContext(event, graphic.type)}
                        onTouchStart={(event) => onTouchStart(event, graphic.type)}
                        onTouchEnd={(event) => onTouchEnd(event, graphic.type)}
                        className={"rectangulo " + graphic.classes}
                      >
                        {graphic.text}
                      </div>
                    </div>
                    // <></>
                  )
                }
                return (<></>)
              })
            }
          </div>
        </div>

        {/* <DropdownMenu menuId="tales" text="" items={} /> */}

      </div>
    </div>
    // <p>Creación de informes</p>
  )
}

export default InformeComponent;